import axios from 'axios';
import { config } from './VariablesGenerales'

//el Path debe ser: ABM_ZON_Companias/ListarEmpresas/

export const llamadaAPI_GET = async (Path) => {
    return axios.get(`${config.peticion}${config.server}:${config.serverPort}/API/${Path}`)
    .catch((error) => {
        if (error.response) {
            // 🔹 Si la API devuelve un error con mensaje, lo mostramos
            const mensajeError = error.response.data.mensajeCompleto || error.response.data.error || "Error desconocido en la API";
            throw new Error(mensajeError);
        } else if (error.request) {
            // 🔹 Si la solicitud no recibió respuesta
            throw new Error("No se recibió respuesta del servidor.");
        } else {
            // 🔹 Si el error es desconocido (problema en la configuración de axios u otra cosa)
            throw new Error(`Error en la petición: ${error.message}`);
        }
    });
};

export const llamadaAPI_GETBinario = async (Path) => {
    try {
        const response = await axios.get(
            `${config.peticion}${config.server}:${config.serverPort}/API/${Path}`,
            { responseType: 'blob' } // Configuración para manejar respuestas binarias
        );

        return response.data; // Devuelve directamente los datos binarios

    } catch (error) {
        if (error.response) {
            // 🔹 Si la API devuelve un error con mensaje, lo mostramos
            const mensajeError = error.response.data.mensajeCompleto || error.response.data.error || "Error desconocido en la API";
            throw new Error(mensajeError);
        } else if (error.request) {
            // 🔹 Si la solicitud no recibió respuesta
            throw new Error("No se recibió respuesta del servidor.");
        } else {
            // 🔹 Si el error es desconocido (problema en la configuración de axios u otra cosa)
            throw new Error(`Error en la petición: ${error.message}`);
        }
    }
};

export const llamadaAPI_GET_conAccessToken = (Path, accessToken) => {
    return axios.get(`${Path}`, {
        headers: {
            'Authorization': `Bearer ${accessToken}`
        }
    });
};

export const llamadaAPI_PUT = async (Path, data) => {
    return axios.put(`${config.peticion}${config.server}:${config.serverPort}/API/${Path}`, data)
    .catch((error) => {
        if (error.response) {
            // 🔹 Si la API devuelve un error con mensaje, lo mostramos
            const mensajeError = error.response.data.mensajeCompleto || error.response.data.error || "Error desconocido en la API";
            throw new Error(mensajeError);
        } else if (error.request) {
            // 🔹 Si la solicitud no recibió respuesta
            throw new Error("No se recibió respuesta del servidor.");
        } else {
            // 🔹 Si el error es desconocido (problema en la configuración de axios u otra cosa)
            throw new Error(`Error en la petición: ${error.message}`);
        }
    });
};

export const llamadaAPI_POST = async (Path, data) => {
    return axios.post(
        `${config.peticion}${config.server}:${config.serverPort}/API/${Path}`,
        data
    ).catch((error) => {
        if (error.response) {
            // 🔹 Si la API devuelve un error con mensaje, lo mostramos
            const mensajeError = error.response.data.mensajeCompleto || error.response.data.error || "Error desconocido en la API";
            throw new Error(mensajeError);
        } else if (error.request) {
            // 🔹 Si la solicitud no recibió respuesta
            throw new Error("No se recibió respuesta del servidor.");
        } else {
            // 🔹 Si el error es desconocido (problema en la configuración de axios u otra cosa)
            throw new Error(`Error en la petición: ${error.message}`);
        }
    });
};

export const llamadaAPI_POSTBinario = async (Path, data) => {
    try {
        const response = await axios.post(
            `${config.peticion}${config.server}:${config.serverPort}/API/${Path}`,
            data,
            { responseType: 'blob' } // Configuración para manejar respuestas binarias
        );

        return response; 

    } catch (error) {
        if (error.response) {
            // 🔹 Si la API devuelve un error con mensaje, lo mostramos
            const mensajeError = error.response.data.mensajeCompleto || error.response.data.error || "Error desconocido en la API";
            throw new Error(mensajeError);
        } else if (error.request) {
            // 🔹 Si la solicitud no recibió respuesta
            throw new Error("No se recibió respuesta del servidor.");
        } else {
            // 🔹 Si el error es desconocido (problema en la configuración de axios u otra cosa)
            throw new Error(`Error en la petición: ${error.message}`);
        }
    }
};

export const llamadaAPI_DELETE = async (Path) => {
    return axios.delete(`${config.peticion}${config.server}:${config.serverPort}/API/${Path}`)
    .catch((error) => {
        if (error.response) {
            // 🔹 Si la API devuelve un error con mensaje, lo mostramos
            const mensajeError = error.response.data.mensajeCompleto || error.response.data.error || "Error desconocido en la API";
            throw new Error(mensajeError);
        } else if (error.request) {
            // 🔹 Si la solicitud no recibió respuesta
            throw new Error("No se recibió respuesta del servidor.");
        } else {
            // 🔹 Si el error es desconocido (problema en la configuración de axios u otra cosa)
            throw new Error(`Error en la petición: ${error.message}`);
        }
    });
};